
<div class="max-page-width">
    <div  class="popular-car-container">
        <div *ngIf="popularCars!=null && popularCars.length > 0">
            <h2 class="text-center mb-4">{{ 'PopularDeals' | translate }}</h2>`
        </div>

        <mat-form-field class="form-control" appearance="none" style="display: none;">
          <mat-datepicker-toggle matPrefix [for]="PickUpDate"></mat-datepicker-toggle>
          <mat-datepicker #PickUpDate></mat-datepicker>
          <input  readonly  formControlName="PickUpDate" matInput
           [matDatepicker]="PickUpDate"
           style="display: none;"

          >
      </mat-form-field>
      <mat-form-field class="form-control" appearance="none" style="display: none;">
        <mat-datepicker-toggle matPrefix [for]="dropUpDate"></mat-datepicker-toggle>
        <mat-datepicker #dropUpDate></mat-datepicker>
        <input  readonly formControlName="dropUpDate" matInput  [matDatepicker]="dropUpDate"


        style="display: none;"
        >
    </mat-form-field>


        <div class="row" id="statisticDiv" #statisticDiv>
          <ng-container *ngIf="popularCars!=null && popularCars.length > 0">
            <div class="col-md-4 popular-car" *ngFor="let popularCar of popularCars">
              <div class="show-image">
                  <div class="">
                  <!-- <img class="img-fluid" src="assets/img/popular-car1.jpg"  [title]="popularCar.makeName"> -->
                  <img class="img-fluid" #ref3 [src]="ref3.getAttribute('src')!=null?ref3.getAttribute('src'):attachmentService
                      .getMMYCarImageLink(popularCar.modelID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.MMYImage,popularCar.makeID,popularCar.modelID,popularCar.year)"
                      [title]="popularCar.makeName" >
                  </div>
                  <div class="popular-car-price">
                      <div class="popular-car-tilte">{{popularCar.makeName}} {{popularCar.modelName}} {{popularCar.year}} {{ popularCar.total}} </div>
                      <!-- <span class="popular-previous-price mr-2"><del>{{popularCar.previousPrice}}</del></span> <span class="popular-current-price">{{popularCar.currentPrice}}</span> / <span>day</span> -->
                      <span class="popular-previous-price mr-2">{{popularCar.className}}</span>
                  </div>
                  <div class="read-more-btn"><input class="read-more" type="button" (click)="readMore(popularCar)" value="{{ 'BookNowButton' | translate }}" /></div>
              </div>
          </div>
          </ng-container>

        </div>
    </div>
</div>





